import { SMART_LOADER_HEADING, SMART_LOADER_PARAGRAPH } from 'Utils/Constants';
import {
  SmartAccountHeadingText, loadingGifV6, maxTablet,
  maxWidth, primaryFont, retina, smMobile400, wMedium,
} from 'Utils/utilsStyle';
import HTMLReactParser from 'html-react-parser';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
  padding: 0px 83px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 0px 65px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 0px 64px;
  }
  @media all and (max-width: ${smMobile400}) {
    padding: 0px 50px;
  }
  .smart-loader-heading {
    ${SmartAccountHeadingText};
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 26px;
      line-height: 32px;
    }
  sup {
    font-size: 17px;
    top: -12px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 12px;
    }
  }
}
.smart-loader-paragraph {
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #7e7e7e;
}
.smart-loader-wrap-animated {
  height: 182px;
  width: 182px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 154px;
    width: 154px;
  }
  img  {
    height: inherit;
    width: inherit;
  }
}
`;

const SmartAccountPlanPreparingLoader = function SmartAccountPlanPreparingLoader() {
  return (
    <Wrapper className="smart-account-plan-preparing-loader">
      <h1 className="smart-loader-heading">
        {HTMLReactParser(SMART_LOADER_HEADING)}
        <sup>TM</sup>
      </h1>
      <p className="smart-loader-paragraph">
        {HTMLReactParser(SMART_LOADER_PARAGRAPH)}
      </p>
      <div className="smart-loader-wrap-animated">
        <img src={loadingGifV6} alt="gillRoyAnimation" />
      </div>
    </Wrapper>
  );
};
export default SmartAccountPlanPreparingLoader;
